export class Posts {

  constructor() {

    let $ = require('jquery');
    let jQueryBridget = require('jquery-bridget');
    let Colcade = require('colcade');

    jQueryBridget('colcade', Colcade, $);

    $('.grid').colcade({
      columns: '.grid-col',
      items: '.grid-item',
    })

    let i;
    let arr = document.querySelectorAll('.aky-accordeon--content');

    for (i = 0; i < arr.length; ++i) {
      let height = arr[i].scrollHeight;
      arr[i].style.setProperty('--max-height', height + 'px');
    }

    $('.aky-accordeon h2').click(function () {

      if (!($(this).hasClass('active'))) {
        $('.open').removeClass('open');
        $('.active').removeClass('active');
      }

      let id = $(this).data('id');

      $(this).toggleClass('active');
      $('#' + id).toggleClass('open');

    });

  }
}



// WEBPACK FOOTER //
// ./js/util/posts.js